import { BoundCallbackObservable } from './BoundCallbackObservable';
export var bindCallback = BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map